export default __webpack_public_path__ + "static/media/A_arte_do_novo_2.87ce4561.jpg";